import type { CultureCode } from '@agency';

export const AVAILABLE_TRANSLATION_LOCALES = [
  'de-AT',
  'de-DE',
  'en-BZ',
  'en-GB',
  'en-PH',
  'en-US',
  'es-AR',
  'es-ES',
  'fr-BE',
  'fr-FR',
  'it-CH',
  'it-IT',
  'nl-BE',
  'pt-BR',
  'pt-PT',
  'es-MX',
] as const satisfies readonly CultureCode[];

export type TranslationLocale = (typeof AVAILABLE_TRANSLATION_LOCALES)[number];

export const DEFAULT_TRANSLATION_LOCALE: TranslationLocale = 'de-DE';
